/* =========================================================================
   OMNIGLOW PDP — interaction layer
   Gallery, quantity stepper, accordion, reveal, sticky buy bar, AJAX ATC.
   Vanilla JS, no dependencies. All logic guarded with __OGPDP_INIT flag
   so repeated section renders (theme editor) don't double-bind.
   ========================================================================= */
(function(){
  if (window.__OGPDP_INIT) return;
  window.__OGPDP_INIT = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, ctx){ return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx){ return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Gallery ---------- */
  function initGallery(root){
    var main = qs('.main-img', root);
    var slides = qsa('.main-img .og-slide', root);
    var thumbs = qsa('.thumbs .thumb', root);
    var prev = qs('.gallery-nav.prev', root);
    var next = qs('.gallery-nav.next', root);
    if (!main || !slides.length || !thumbs.length) return;

    var isMobile = function(){ return window.matchMedia('(max-width: 768px)').matches; };
    var currentIdx = 0;

    function show(n){
      if (n < 0) n = slides.length - 1;
      if (n >= slides.length) n = 0;
      currentIdx = n;
      if (isMobile()){
        var target = slides[n];
        if (target){
          main.scrollTo({ left: target.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' });
        }
        thumbs.forEach(function(t, k){ t.classList.toggle('active', k === n); });
      } else {
        slides.forEach(function(s, k){ s.classList.toggle('active', k === n); });
        thumbs.forEach(function(t, k){ t.classList.toggle('active', k === n); });
        slides.forEach(function(s, k){
          var v = s.querySelector('video');
          if (v && k !== n) { try{ v.pause(); }catch(e){} }
        });
      }
    }
    thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ show(k); }); });
    if (prev) prev.addEventListener('click', function(){ show(currentIdx - 1); });
    if (next) next.addEventListener('click', function(){ show(currentIdx + 1); });

    // Sync current index with swipe position on mobile
    var scrollTimer;
    main.addEventListener('scroll', function(){
      if (!isMobile()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        var w = main.clientWidth;
        var idx = Math.round(main.scrollLeft / w);
        currentIdx = idx;
        thumbs.forEach(function(t, k){ t.classList.toggle('active', k === idx); });
      }, 60);
    }, { passive: true });

    show(0);
  }

  /* ---------- Mode selector ---------- */
  function initModeSelector(root){
    qsa('.mode-grid', root).forEach(function(grid){
      var btns = qsa('.mode-btn', grid);
      btns.forEach(function(btn){
        btn.addEventListener('click', function(){
          btns.forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
        });
      });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function initQty(root){
    qsa('.qty-box', root).forEach(function(wrap){
      var input = qs('input', wrap);
      var btns = qsa('.qty-btn', wrap);
      if (!input || btns.length < 2) return;
      function clamp(v){ var n = parseInt(v, 10); if (isNaN(n) || n < 1) n = 1; if (n > 10) n = 10; return n; }
      btns[0].addEventListener('click', function(){ input.value = clamp(parseInt(input.value, 10) - 1); });
      btns[1].addEventListener('click', function(){ input.value = clamp(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function(){ input.value = clamp(input.value); });
    });
  }

  /* ---------- AJAX Add-to-cart ---------- */
  function initATC(root){
    qsa('.og-atc-form', root).forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('.cta-primary');
        var originalText = btn ? btn.textContent : '';
        if (btn) { btn.classList.add('loading'); btn.textContent = 'Adding…'; }

        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function(r){
            if (!r.ok){
              return r.text().then(function(t){
                var msg = 'Could not add to bag';
                try{ var j = JSON.parse(t); msg = j.description || j.message || msg; }catch(_){}
                throw new Error(msg);
              });
            }
            return r.json();
          })
          .then(function(){
            if (btn) { btn.classList.remove('loading'); btn.textContent = '✓ Added'; setTimeout(function(){ btn.textContent = originalText || 'Add to bag'; }, 1600); }
            if (window.gvMiniCart && window.gvMiniCart.open) { window.gvMiniCart.open(); }
            else { window.location.href = '/cart'; }
          })
          .catch(function(err){
            if (btn) { btn.classList.remove('loading'); btn.textContent = originalText || 'Add to bag'; }
            // Fallback to native form submission so the customer still gets added
            alert(err.message || 'Could not add to bag. Redirecting to cart…');
            form.removeEventListener('submit', arguments.callee);
            form.submit();
          });
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root){
    var all = qsa('.reveal', root);
    if (REDUCED || !('IntersectionObserver' in window)){
      all.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });
    all.forEach(function(el){ io.observe(el); });
    // Safety net: after 2s, reveal anything still missed (e.g. inside closed details, off-screen forever)
    setTimeout(function(){
      all.forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight + 200 && !el.classList.contains('in')){
          el.classList.add('in');
        }
      });
    }, 2000);
  }

  /* ---------- Sticky buy bar ---------- */
  function initStickyBar(){
    var bar = qs('.omniglow-pdp-stickybar');
    var hero = qs('.product-hero');
    var heroAtc = qs('.product-hero .cta-primary');
    if (!bar || !hero) return;
    if (!('IntersectionObserver' in window)) return;

    // Show the sticky bar only when the whole PDP hero has scrolled out of view.
    // On mobile, we watch the hero section (not the ATC button) so nothing pops
    // up mid-hero while the customer is still reading the price/title.
    var isMobile = function(){ return window.matchMedia('(max-width: 768px)').matches; };

    function setup(){
      if (window.__og_sticky_io){ window.__og_sticky_io.disconnect(); }
      var target = isMobile() ? hero : (heroAtc || hero);
      var rootMargin = isMobile() ? '0px 0px 0px 0px' : '-80px 0px 0px 0px';
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          bar.classList.toggle('visible', !e.isIntersecting);
        });
      }, { threshold: 0, rootMargin: rootMargin });
      io.observe(target);
      window.__og_sticky_io = io;
    }
    setup();
    window.addEventListener('resize', function(){
      clearTimeout(window.__og_sticky_resize);
      window.__og_sticky_resize = setTimeout(setup, 200);
    });

    var stickyBtn = qs('.sticky-cta', bar);
    if (stickyBtn){
      stickyBtn.addEventListener('click', function(){
        var form = qs('.og-atc-form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- Reviews toggle ---------- */
  function initReviews(root){
    var toggle = qs('.og-reviews-toggle', root);
    var cards = qsa('.review-card', root);
    if (!toggle || !cards.length) return;
    var initial = parseInt(toggle.getAttribute('data-initial') || '6', 10);
    var expanded = false;
    var originalText = toggle.innerHTML;
    var section = toggle.closest('.reviews') || toggle.closest('section');

    function apply(){
      cards.forEach(function(c, k){
        c.classList.toggle('visible', expanded || k < initial);
        // reveal cards that are now shown so they are not stuck at opacity:0
        if (expanded || k < initial) c.classList.add('in');
      });
      if (expanded){
        toggle.textContent = 'Show fewer reviews';
      } else {
        toggle.innerHTML = originalText;
      }
    }
    toggle.addEventListener('click', function(){
      expanded = !expanded;
      apply();
      if (!expanded && section){
        section.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      }
    });
    apply();
  }

  /* ---------- UGC videos: autoplay in view, pause out of view, tap to expand ---------- */
  function initUgcPosters(root){
    var videos = qsa('.ugc-video', root);
    if (!videos.length) return;

    // Play videos lazily: only when (nearly) in view; pause out of view
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){
            e.target.preload = 'auto';
            e.target.muted = true;
            var p = e.target.play();
            if (p && typeof p.catch === 'function') p.catch(function(){});
          } else {
            try{ e.target.pause(); }catch(err){}
          }
        });
      }, { threshold: 0.25, rootMargin: '200px 0px' });
      videos.forEach(function(v){ io.observe(v); });
    } else {
      // No IntersectionObserver: play only the first video so the wall isn't frozen
      var firstV = videos[0];
      firstV.preload = 'auto';
      firstV.muted = true;
      var fp = firstV.play();
      if (fp && typeof fp.catch === 'function') fp.catch(function(){});
    }

    // Lightbox: tap a card (or its play button) to open the video with sound + controls
    var lightbox = qs('.ugc-lightbox', root);
    if (!lightbox) return;
    var lbVideo = qs('.ugc-lightbox-video', lightbox);
    var lbClose = qs('.ugc-lightbox-close', lightbox);

    function openLb(src){
      if (!src || !lbVideo) return;
      lbVideo.src = src;
      lbVideo.muted = false;
      lbVideo.currentTime = 0;
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var p = lbVideo.play();
      if (p && typeof p.catch === 'function') p.catch(function(){});
    }
    function closeLb(){
      if (lbVideo){ try{ lbVideo.pause(); }catch(e){} lbVideo.removeAttribute('src'); lbVideo.load(); }
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    qsa('.ugc-card', root).forEach(function(card){
      var v = card.querySelector('.ugc-video');
      var playBtn = card.querySelector('.play');
      function handle(e){
        e.preventDefault();
        e.stopPropagation();
        var src = v && (v.currentSrc || (v.querySelector('source') && v.querySelector('source').src));
        openLb(src);
      }
      if (playBtn) playBtn.addEventListener('click', handle);
      card.addEventListener('click', function(e){
        // ignore clicks on the video element itself (pointer-events:none anyway)
        if (e.target === playBtn || (playBtn && playBtn.contains(e.target))) return;
        handle(e);
      });
    });

    if (lbClose){
      lbClose.addEventListener('click', function(e){ e.stopPropagation(); closeLb(); });
      lbClose.addEventListener('touchend', function(e){ e.stopPropagation(); closeLb(); }, { passive: true });
    }
    // Any tap outside the video container closes the lightbox
    lightbox.addEventListener('click', function(e){
      if (!e.target.closest('.ugc-lightbox-inner')) closeLb();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLb();
    });
  }

  /* ---------- Init everything ---------- */
  function boot(){
    var anyWrapper = qs('.omniglow-pdp-wrapper');
    if (!anyWrapper) return;
    // Hero-scoped inits (only one hero on the page)
    initGallery(document);
    initModeSelector(document);
    initQty(document);
    initATC(document);
    // Page-wide inits: every section has its own .omniglow-pdp-wrapper,
    // so scan the whole document, not just the first wrapper.
    initReveal(document);
    initReviews(document);
    initStickyBar();
    initUgcPosters(document);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init for theme editor
  document.addEventListener('shopify:section:load', function(e){
    if (!e.target.closest || !e.target.closest('.omniglow-pdp-wrapper, [data-og-section]')) return;
    window.__OGPDP_INIT = false;
    setTimeout(function(){
      window.__OGPDP_INIT = true;
      boot();
    }, 0);
  });
})();
